export function cloudinaryTransforms(picture, transforms) {
  const cloudinaryUrl = 'https://res.cloudinary.com/das-pdp-rit/image/upload/';
  if (picture.includes(cloudinaryUrl)) {
    let [transform, ...parts] = picture.split(cloudinaryUrl)[1].split('/');
    transform = transforms;
    picture = `${cloudinaryUrl}${transform}/${parts.join('/')}`;
  }
  return picture;
}
